(ns io.daskul.tutorial.webapp.domain.active-context.events
  "Active context events — branch/school switching (F-041).

   Manages which branch/school the user is currently 'looking at'.
   Separate from JWT security boundary (what they CAN access).
   Persisted to localStorage for page reload survival.
   HTTP headers attached automatically via client/auth-header."
  (:require
   [re-frame.core :as rf]
   [io.daskul.webapp.active-context :as ac]))

(def ^:private storage-key "active-context")

(defn- read-storage
  "Read active context from localStorage. Returns map or nil."
  []
  (try
    (when-let [raw (.getItem js/localStorage storage-key)]
      (js->clj (js/JSON.parse raw) :keywordize-keys true))
    (catch :default _ nil)))

;; Initialize: restore from localStorage, or default from JWT singular IDs.
;; Called on login and page reload.
;;
;; SMS-272 Layer 2: a single-branch school (or a stored nil-branch context on
;; one) auto-pins its sole branch — see io.daskul.webapp.active-context. The
;; pure resolver decides the context + whether to persist; this event just reads
;; localStorage + wires the effects.
(rf/reg-event-fx
 ::initialize
 (fn [{:keys [db]} [_ {:keys [school-id branch-id available-contexts]}]]
   (let [{:keys [active persist?]}
         (ac/resolve-context (read-storage)
                             {:school-id school-id :branch-id branch-id}
                             available-contexts)]
     (cond-> {:db (assoc db :active-context active)}
       persist? (assoc :localstorage/set
                       [storage-key (js/JSON.stringify (clj->js active))])))))

;; Select a different branch. nil = "All branches" (no branch filter).
(rf/reg-event-fx
 ::select-branch
 (fn [{:keys [db]} [_ branch-id]]
   (let [ctx (if branch-id
               (assoc (:active-context db) :branch-id branch-id)
               (dissoc (:active-context db) :branch-id))]
     {:db (assoc db :active-context ctx)
      :localstorage/set [storage-key (js/JSON.stringify (clj->js ctx))]})))

;; Select a different school
(rf/reg-event-fx
 ::select-school
 (fn [{:keys [db]} [_ school-id]]
   (let [ctx (assoc (:active-context db) :school-id school-id)]
     {:db (assoc db :active-context ctx)
      :localstorage/set [storage-key (js/JSON.stringify (clj->js ctx))]})))

;; Clear on logout
(rf/reg-event-fx
 ::clear
 (fn [{:keys [db]} _]
   {:db (dissoc db :active-context)
    :localstorage/remove storage-key}))
